import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_CsvInput = _resolveComponent("CsvInput")!

  return (_openBlock(), _createElementBlock("div", {
    class: "full-width",
    tabindex: "-1",
    ref: _ctx.templateRefContainer,
    onFocusout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onFocusOut($event)))
  }, [
    _createVNode(_component_el_checkbox, {
      modelValue: _ctx.modelValue.allSelected,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modelValue.allSelected) = $event)),
      label: "Select All"
    }, null, 8 /* PROPS */, ["modelValue"]),
    _createVNode(_component_CsvInput, {
      modelValue: _ctx.modelValue.specific,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modelValue.specific) = $event)),
      selectableData: _ctx.selectableData,
      separator: _ctx.separator,
      placeholder: _ctx.placeholder,
      disabled: _ctx.modelValue.allSelected
    }, null, 8 /* PROPS */, ["modelValue", "selectableData", "separator", "placeholder", "disabled"])
  ], 544 /* HYDRATE_EVENTS, NEED_PATCH */))
}